import { Field, Form, ModalLayoutCenter } from "@kanda-libs/ks-component-ts";
import { Button, Loader } from "@kanda-libs/ks-design-library";
import type { FunctionComponent, MutableRefObject } from "react";
import { VALIDATION } from "components/company/CompanyDeclineModal/constants";
import useDeclineCompanyForm from "components/company/CompanyDeclineModal/useDeclineCompanyForm";

export interface CompanyDeclineModalFormProps {
  handleClose: () => void;
  ref?: MutableRefObject<HTMLElement | undefined>;
}

const CompanyDeclineModalForm: FunctionComponent<CompanyDeclineModalFormProps> =
  function ({ handleClose, ref }) {
    const { form, isSubmitting, options, onSubmit } =
      useDeclineCompanyForm(handleClose);

    return (
      <>
        <ModalLayoutCenter
          id="staff-company-decline"
          onClose={handleClose}
          ref={ref as MutableRefObject<HTMLDivElement>}
          className="w-10/12 p-4 md:w-160"
        >
          <Form
            id="staff-company-decline"
            form={form}
            onSubmit={onSubmit}
            className="flex flex-col w-full"
          >
            <p className="mb-4 text-20-24-em">Decline company</p>
            <p className="mb-6">
              Please select a reason for declining this company:
            </p>
            <Field.Validator validation={VALIDATION}>
              <Field.Select
                name="reason"
                label="Decline reason"
                placeholder="Select decline reason"
                options={options}
              />
            </Field.Validator>
            <Button.Text
              id="staff-company-decline"
              submit
              disabled={isSubmitting}
              label="Submit"
              className="mx-auto"
            />
          </Form>
        </ModalLayoutCenter>
        <Loader isLoading={isSubmitting} />
      </>
    );
  };

export default CompanyDeclineModalForm;
